import usePageTitle from "../utils/hooks/usePageTitle";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  usePageTitle("Error");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-900">
      <h1 className="text-6xl font-bold text-red-500">403</h1>
      <p className="text-2xl mt-4">Access Denied</p>
      <p className="text-lg mt-2 text-gray-600">You do not have permission to view this page.</p>
      <Link
        to="/dashboard"
        className="mt-6 px-6 py-3 bg-blue-700 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-800 transition"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default ErrorPage;
